import { ScrollPanelModule } from 'primeng-lts/scrollpanel';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { userDetailComponent } from './userDetail.component';
import { FormsModule } from '@angular/forms';
import { WaitLoadingModule } from '../../components/common/waitLoading/waitLoading.module';
import { TranslateModule } from '@ngx-translate/core';
import { SubHeaderModule } from '../../components/common/sub-header/sub-header.module';
import { PanelModule } from 'primeng-lts/panel';

@NgModule({
    declarations: [userDetailComponent],
    imports: [TranslateModule, CommonModule, FormsModule, WaitLoadingModule, PanelModule, SubHeaderModule, ScrollPanelModule],
    exports: [userDetailComponent]
})

export class UserDetailModule { }